import '@creative-tim-official/argon-dashboard-pro/assets/vendor/bootstrap/dist/js/bootstrap.bundle.min.js';
import '@creative-tim-official/argon-dashboard-pro/assets/js/argon';

import Headroom from 'headroom.js';

window.Headroom = Headroom;



// WEBPACK FOOTER //
// ./static/src/js/layouts/base.js